import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'

export type BookingView = 'my' | 'team'

interface BookingViewToggleProps {
  view: BookingView
  onViewChange: (view: BookingView) => void
}

export default function BookingViewToggle({
  view,
  onViewChange
}: BookingViewToggleProps) {
  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newView: BookingView | null
  ) => {
    if (newView !== null) {
      onViewChange(newView)
    }
  }

  return (
    <ToggleButtonGroup
      value={view}
      exclusive
      onChange={handleChange}
      aria-label='booking view toggle'
      fullWidth
    >
      <ToggleButton value='my' aria-label='my bookings'>
        My Bookings
      </ToggleButton>
      <ToggleButton value='team' aria-label='my team bookings'>
        My Team Bookings
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
